import { render, staticRenderFns } from "./BillingAddress.vue?vue&type=template&id=09a5c834"
import script from "./BillingAddress.vue?vue&type=script&lang=js"
export * from "./BillingAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09a5c834')) {
      api.createRecord('09a5c834', component.options)
    } else {
      api.reload('09a5c834', component.options)
    }
    module.hot.accept("./BillingAddress.vue?vue&type=template&id=09a5c834", function () {
      api.rerender('09a5c834', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/customers/view/BillingAddress.vue"
export default component.exports